<template>
    <el-form
        ref="loginForm"
        :rules="rules"
        :model="user"
        class="login-form" label-position="top" size="large"
    >
        <el-header class="text-center h2 py-3">
            Iniciar sessão
        </el-header>
        <el-form-item label="Insira seu teefone" prop="phone">
            <el-input type="number" :min="820000000" :max="879999999" :step='1' v-model="user.phone" placeholder="Celular" prefix-icon="Phone">
            </el-input>
        </el-form-item>
        <el-form-item label="Insira sua senha" prop="password">
            <el-input v-model="user.password" type="password" placeholder="Senha" prefix-icon="Lock" show-password>
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button 
                type="primary"
                class="login-button col-12 col-md-auto m-1"
                @click="handleLogin(loginForm)"
                :loading="loading"
            >Entrar</el-button>
        </el-form-item>
    </el-form>
</template>

<script lang="ts" setup>
    import { ref, reactive } from 'vue';
    import { useStore } from 'vuex';
    import { ElMessage } from 'element-plus';
    import type { FormInstance, FormRules } from 'element-plus'
    import Api from '@/services/api'
    import { User } from '@/services/types'

    const store = useStore();

    const loading = ref<boolean>(false)

    const loginForm = ref<FormInstance>()
    const rules = reactive<FormRules<User>>({
        phone: [
            { required: true, message: 'Por favor insira o numero de telefone', trigger: 'blur'},
        ],
        password: [
            { required: true, message: 'Por favor digite a senha', trigger: 'blur'},
        ],
    })
    const user = reactive<User>({
        phone: null,
        password: '',
    })
    const handleLogin = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                console.log(user)
                const res = await Api.post("/auth/login", {
                    phone: user.phone,
                    password: user.password
                })
                console.log(res)
                if ((res.status >= 200 && res.status < 300) && (res.data.user.role == 'admin' || res.data.user.role == 'master')) {

                    store.dispatch('login', res.data.token)
                    sessionStorage.setItem("user", JSON.stringify(res.data.user))
                    window.location.href = "/home"
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        loginForm.value?.fields.forEach((val) => {
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage({
                        type: "error",
                        message: "Ocorreu um erro ao tentar iniciar sessão"
                    })
                }
                loading.value = false
            } else {
                ElMessage.error({
                    message: "Por favor preencha corretamente"
                })
            }
        })
    }
</script>
